/**
 * 金額 / 數量的共用 zod 型別(REQ-20260806002)。
 *
 * JSON 沒有 decimal,數字用 float 傳會在小數位吃掉精度,所以一律以字串進出 API。
 * 這裡接受 number 只是為了讓前端表單少一層轉換,收下後立刻轉成字串。
 * 原本這段只存在於 sales-order.schema.ts,會計四個模組都要用,抽出來共用。
 */
import { z } from 'zod';

/** 允許正負整數 / 小數的字串,例:'123'、'-1.5'、'0.0500' */
export const decimalString = z
  .union([z.string(), z.number()])
  .transform((v) => (typeof v === 'number' ? String(v) : v))
  .refine((s) => /^-?\d+(\.\d+)?$/.test(s.trim()), '金額格式不正確')
  .transform((s) => s.trim());

/** 不可為負的金額 / 數量 */
export const nonNegativeDecimalString = decimalString.refine(
  (s) => Number(s) >= 0,
  '不可為負數',
);

/** 正數(數量、單價之類不接受 0 的欄位) */
export const positiveDecimalString = decimalString.refine(
  (s) => Number(s) > 0,
  '必須大於 0',
);
